import React from "react";
import {Space, Form, Row, Col, Button} from "antd";
import "./Child.scss";
type Info = {
  name: string;
  age: number;
  major: string;
};
type Props = {
  info: Info;
  callback: Function;
};
const Child = (props: Props) => {
  const {info, callback} = props;
  const {name, age, major} = info;
  return (
    <div className="child">
      <div style={{fontWeight: 600, textAlign: "center"}}>Child</div>
      <Space direction="vertical">
        <div>
          Tên: <span>{name}</span>
        </div>
        <div>
          Tuổi: <span>{age}</span>
        </div>
        <div>
          Vị trí: <span>{major}</span>
        </div>

        <div>
          <Button
            type="primary"
            onClick={() => callback({value: "Dữ liệu của component con"})}
          >
            Gửi thông tin
          </Button>
        </div>
      </Space>
    </div>
  );
};
export default Child;
